<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex>Add Project Banner</v-flex>
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                        <v-flex wrap style="padding: 10px;">
                            <v-flex>
                                <v-select item-value='_id' item-text='name' return-object v-model="SelectedMiniProject" :items="MiniProjects" label="Select Mini Project">
                                    <template slot='selection' slot-scope='{ item }'>
                                        {{ item.Project_Title }}
                                    </template>
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.Project_Title }}    
                                    </template>
                                </v-select>
                            </v-flex>
                            <div style="width:400px;margin:auto;border: 1px solid #d3d3d37a;">
                                <v-flex>
                                    <img id="img" v-if="Image_File" :src="url" width="100%" />
                                </v-flex>
                                <v-flex style="text-align: center;">
                                    <v-btn color="primary" @click="$refs.inputUpload.click()">Upload Image    </v-btn>
                                    <input v-show="false" ref="inputUpload" type="file" @change="SelectedFile" >
                                </v-flex>
                            </div>
                        </v-flex>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-flex style="text-align: right;">
                            <v-btn color="primary" @click="SubmitBannerImage">Add Course Banner</v-btn>
                        </v-flex>
                    </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>

export default {
    props: ['dialog'],
    data(){
        return {

            SelectedMiniProject    : {},
            url                     : null,
            Image                   : null,
            Image_File              : false,
            MiniProjects            : []
        }
    },
    methods:{
        SelectedFile(e){
        
            this.Image = e.target.files[0]
            if(this.Image.type.split('/')[0] == "image"){
                
                this.Image_File = true
                this.url = URL.createObjectURL(this.Image);

            }else{
                
                this.Image_File = false
                this.url = URL.createObjectURL(this.Image);
            }

        },
        SubmitBannerImage(){
            
            if(this.Image && Object.keys(this.SelectedMiniProject).length > 0){

                const fd = new FormData()
                fd.append('Project_Banner',this.Image,this.Image.name)
                fd.append('Project_Id',this.SelectedMiniProject['_id'])
                let Preview_URL = `${this.$store.getters.GetProductionUrl}/miniproject/addprojectbanner`
                this.$http.post(Preview_URL,fd)
                            .then(response =>{
    
                                this.$store.commit('UpdateCourseDetails',response['data']['response'])
                                this.CloseDialog()   
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Uploaded Image","Color":"green","Close": false });
                                 
                            })
                            .catch(err =>{
    
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Upload Image","Color":"red","Close": false });
                            })
            }else{

                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Select Image and Project ","Color":"red","Close": false });
            }

        },
        ClearForm(){

            this.url        = null
            this.Image      = null
            this.Image_File = false
            this.SelectedMiniProject    = {}
            this.$refs.inputUpload.value = ""   
     
        },
        GetMiniProjectList(){

            return new Promise((resolve,reject) =>{

                this.$http.post(`${this.$store.getters.GetProductionUrl}/miniproject/getminiprojects`,{})
                            .then(response =>{
    
                                this.MiniProjects = response["data"]["response"]
                                resolve(true)
                            })
                            .catch(err =>{
    
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Fetch Data","Color":"red","Close": false });
                                reject(err)
                            })
            })

        },
        CloseDialog(){

            this.ClearForm()
            this.$emit('close')

        }
    }
}
</script>
<style scoped>

</style>